import './components/lightbox';
import './components/navigation';

import '../../node_modules/bootstrap/js/src/carousel';

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR');
    });
}

const printButton = Array.from(document.querySelectorAll('.print-button'));
printButton.forEach(button => {
    button.addEventListener('click', e => {
        e.preventDefault();
        window.print();
    });
});
